import { DataTable } from '@app/components/data-table/data-table';
import { DataTableToolbar } from '@app/components/data-table/data-table-toolbar';
import { useServerDataTable } from '@app/components/data-table/hooks/use-server-data-table';
import { DataTableProps } from '@app/components/data-table/types/data-table';
import { PaginatedGroupPackagingList } from '@shared/api/types';
import { useGroupPackagingColumns } from './group-packaging-table-columns';
import { FilterOption, toFilterOptions } from './group-purchased-goods-columns';

interface GroupPackagingTableProps
  extends DataTableProps<PaginatedGroupPackagingList> {
  pageCount: number;
}

export default function GroupPackagingTable({
  data,
  status,
  isLoading,
  isFetchedAfterMount,
  isPreviousData,
  pageCount,
}: GroupPackagingTableProps) {
  const filters = data?.filters;

  const ratingOptions: FilterOption[] = toFilterOptions(
    filters?.carbonIntensityCategories
  );
  const supplierOptions: FilterOption[] = toFilterOptions(filters?.suppliers);

  const { table, context } = useServerDataTable({
    data: data?.results ?? [],
    columns: useGroupPackagingColumns({
      ratingOptions,
      supplierOptions,
    }),
    pageCount,
    initialState: {
      columnVisibility: {
        supplier: false,
      },
    },
  });

  return (
    <DataTable
      table={table}
      context={context}
      className="bg-gray-00"
      isLoading={(!isFetchedAfterMount && isPreviousData) || isLoading}
      tableLoading={!data && status === 'loading'}
    >
      <DataTableToolbar table={table} />
    </DataTable>
  );
}
